import validate from "/home/runner/work/app/app/node_modules/nuxt/dist/pages/runtime/validate.js";
import _02_45permission_45global from "/home/runner/work/app/app/middleware/02.permission.global.ts";
import _03_45admin_452fa_45global from "/home/runner/work/app/app/middleware/03.admin-2fa.global.ts";
import _03_45module_45global from "/home/runner/work/app/app/middleware/03.module.global.ts";
import _04_45first_45login_45global from "/home/runner/work/app/app/middleware/04.first-login.global.ts";
import _05_45patient_45id_45guard_45global from "/home/runner/work/app/app/middleware/05.patient-id-guard.global.ts";
import admin_45global from "/home/runner/work/app/app/middleware/admin.global.ts";
import manifest_45route_45rule from "/home/runner/work/app/app/node_modules/nuxt/dist/app/middleware/route-rules.js";
export const globalMiddleware = [
  validate,
  _02_45permission_45global,
  _03_45admin_452fa_45global,
  _03_45module_45global,
  _04_45first_45login_45global,
  _05_45patient_45id_45guard_45global,
  admin_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  auth: () => import("/home/runner/work/app/app/middleware/auth.ts")
}